import { inject, Injectable } from '@angular/core';
import { HttpUtil } from '../../../shared/util/http.util';
import { Observable } from 'rxjs';
import { RegionModel } from '../model/region.model';
import { Page } from '../../../shared/model/local/pagination/page';
import { RegionProductPageCriteria } from '../model/region-product-page-criteria';
import { Product } from '../model/product.model';
import { ModifyRegionModel } from '../model/modify-region.model';
import { environment } from '../../../../environment/environment';

@Injectable({ providedIn: 'root' })
export class RegionApiService {
  apiUrl = environment.apiUrl + '/api/admin';

  private readonly _http = inject(HttpUtil);

  getRegionDetails(regionId: number): Observable<RegionModel> {
    return this._http.get(`${this.apiUrl}/regions/${regionId}`);
  }

  getProductsPage(
    distributorId: number,
    criteria: RegionProductPageCriteria
  ): Observable<Page<Product>> {
    return this._http.get(
      `${this.apiUrl}/distributors/${distributorId}/products/page`,
      criteria
    );
  }

  createRegion(payload: ModifyRegionModel): Observable<void> {
    return this._http.post(`${this.apiUrl}/regions`, payload);
  }

  editRegion(payload: ModifyRegionModel, id: number): Observable<void> {
    return this._http.put(`${this.apiUrl}/regions/${id}`, payload);
  }
}
